import { Button } from '@/components/ui/button';
import BackSpaceIcon from '@/icons/back-space-icon';
import { SoundContext } from '@/pages/(gapsdk)/_provider/sound-provider';
import { useContext } from 'react';
import { useForm } from 'react-hook-form';

interface FormValues {
  code: string;
}
const formatCode = (input: string) => {
  return input.replace(/(.{4})/g, '$1-').replace(/-$/, '');
};

export default function KeyboardCustom({
  onCheckSuccess,
}: {
  onCheckSuccess: (code: string) => void;
}) {
  const { event } = useContext(SoundContext);

  const { setValue, watch, reset } = useForm<FormValues>({
    defaultValues: {
      code: '',
    },
  });

  const code = watch('code');

  const handleNumberPress = (num: number) => {
    const cleaned = code.replace(/-/g, '');
    if (cleaned.length >= 32) return;
    setValue('code', formatCode(cleaned + num));
  };

  const handleBackspace = () => {
    const cleaned = code.replace(/-/g, '');
    setValue('code', formatCode(cleaned.slice(0, -1)));
  };

  const handleClear = () => {
    reset();
  };

  const NUMERIC_BUTTONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 'C', 0, 'x'];

  return (
    <div className="mx-auto flex min-w-[800px] max-w-md flex-col gap-4">
      <div className="text-center text-2xl">Input gift card code</div>
      <div className="w-full rounded-lg bg-[#F8F8F8] p-4 text-center text-4xl font-semibold">
        {code || <span className="text-gray-300">0000-0000-0000-0000</span>}
      </div>
      <div className="grid grid-cols-3 gap-2">
        {NUMERIC_BUTTONS.map((num, i) => (
          <button
            key={i}
            className="click-effect h-[108px] w-full rounded-lg border border-[#E8E8E8] bg-white text-5xl font-bold"
            onClick={() => {
              event.playTap();
              if (num === 'C') {
                handleClear();
                return;
              }
              if (num === 'x') {
                handleBackspace();
                return;
              }
              handleNumberPress(num as number);
            }}
          >
            {num === 'x' ? (
              <div className="flex items-center justify-center">
                <BackSpaceIcon
                  style={{
                    width: 48,
                    height: 48,
                  }}
                />
              </div>
            ) : (
              num
            )}
          </button>
        ))}
      </div>
      <Button
        className="h-[96px] rounded-md bg-[#2F80ED] text-2xl font-bold hover:bg-[#2F80ED]/90"
        onClick={() => {
          event.playTap();
          onCheckSuccess(code);
        }}
        disabled={code.length === 0}
      >
        Check
      </Button>
    </div>
  );
}
